// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2pxvH","selects":"Documents_selects__Sryce"};